<template>
  <div class="driversEdit">
      <div class="row"> 
                      <div class="col-md-12">
                        <h1 class="labelBold">
                          {{$t("mobilityOnDemand.editDrivers.title")}}
                        </h1>
                       </div>
      </div>
       <div class="row"> 
            <div class="col-md-9">

            </div>
                  
                           
                          <div class="col-md-3">
                                <button class="btn-cancel" @click="link">
                                   {{ $t("mobilityOnDemand.editDrivers.back") }}
                                </button>
                                <button class="btn-confirm" @click="showModal">
                                    {{ $t("mobilityOnDemand.editDrivers.save") }}
                                </button>
                          </div>
                         
       
        </div>
    
    <div class="row">
                      <!-- Número de control -->
                      <div class="col-md-4">
                      <label class="labelBold mt-2">
                          {{ $t("mobilityOnDemand.editDrivers.controlNumber") }}
                      </label>
                      <input type="text" v-model="controlNumber" disabled/>
                      </div>
                            <!-- Correo Electrónico -->
                            <div class="col-md-4">
                            <label class="labelBold mt-2">
                                {{ $t("mobilityOnDemand.editDrivers.email") }}
                            </label>
                            <input type="text" v-model="email" disabled/>
                            </div>
                                    <!-- Celular -->
                                    <div class="col-md-4">
                                    <label class="labelBold mt-2">
                                        {{ $t("mobilityOnDemand.editDrivers.phone")}}
                                    </label>
                                    <input type="tel" v-model="phoneNumber" disabled/>
                                    </div>
                               
    </div>
    
      <div class="row">
           <!-- Nombre -->
          <div class="col-md-4">
          <label class="labelBold mt-2">
              {{ $t("mobilityOnDemand.editDrivers.name") }}
          </label>
          <input type="text" v-model="name" disabled/>
          </div>
                        <!-- Apellido Paterno -->
                        <div class="col-md-4">
                        <label class="labelBold mt-2">
                            {{ $t("mobilityOnDemand.editDrivers.lastName") }}
                        </label>
                        <input type="text" v-model="lastName" disabled/>
                        </div>
                                <!-- Apellido Materno -->
                                <div class="col-md-4">
                                <label class="labelBold mt-2">
                                    {{ $t("mobilityOnDemand.editDrivers.motherLastName") }}
                                </label>
                                <input type="text" v-model="mothersLastName" disabled/>
                                </div>
                                    
      </div>
        <div class="row">
                    
                          <!-- Tipo -->
                                      <div class="col-md-4">
                                      <label class="labelBold mt-2">
                                          {{ $t("mobilityOnDemand.editDrivers.type") }}
                                      </label>
                                      <input type="text" v-model="type" disabled/>
                                      </div>
                              <!-- Driver -->
                              <div class="col-md-4">
                                          <label class="labelBold mt-2">
                                              {{ $t("mobilityOnDemand.editDrivers.typeUser") }}
                                          </label>
                                          <input type="text" v-model="typeUser" disabled />
                               

                              </div>
                                        <!-- Tipo Usuario -->
                                     
                                        <div class="col-md-4">
                                             <label for="status" class="labelBold">
                                                {{ $t("mobilityOnDemand.editDrivers.driver") }}
                                               </label>
                                               <br/>
                                              <div v-if="create==true">
                                               <select class="form-control mt-2" id ="statusTru" v-model="selected" >
                                                          <option v-for="option in options"
                                                          v-bind:key="option.id"
                                                          v-bind:value="option.id">
                                                          {{option.name}}
                                                          </option>
                                                    </select>
                                              </div>
                                                <div v-else-if="create==false">
                                                  <select class="form-control mt-2" id ="statusFal" v-model="selected" >
                                                          <option v-for="option in optionsUpdate"
                                                          v-bind:key="option.id"
                                                          v-bind:value="option.id">
                                                          {{option.name}}
                                                          </option>
                                                    </select>
                                                </div>
                                        </div>
                                     

        </div>
 
     <b-modal centered ref="my-modal" hide-footer hide-header  tabindex="-1" >
   
      <div class="aui-headline-3" >
     
         <b-button size="lg" class="pull-right" style="height:80px; width:60px;font-size:30px; background-color:#ffffcc; color:#FFCD00" variant="outline-gray" @click="hideModal()"><h1>X</h1></b-button>
  
        <div class="row">
          <div class="alertBg col-md-12">
            <h4 >  {{ $t("mobilityOnDemand.editDrivers.confirmation") }}</h4>
          
               <div class="RedText"  v-if="create==true">
                                           {{ $t("mobilityOnDemand.editDrivers.create") }}
                                        </div>
                                          <div class="alertText" v-else-if="create==false">
                                               {{ $t("mobilityOnDemand.editDrivers.alert") }}
                                              </div>
           
            </div>
            

        </div>

       <br/>
         <p>
               <label class="labelBold mt-2">
                {{ $t("mobilityOnDemand.editDrivers.controlNumber") }}
               </label>: {{controlNumber}}
          </p>

          <label class="labelBold mt-2">
                                                {{ $t("mobilityOnDemand.editDrivers.driver") }}:
          </label>
            <div v-if="create==true">
                                               <select class="form-control" id ="statusTrue1" v-model="selected" disabled >
                                                          <option v-for="option in options"
                                                          v-bind:key="option.id"
                                                          v-bind:value="option.id">
                                                          {{option.name}}
                                                          </option>
                                                    </select>
                                              </div>
                                                <div v-else-if="create==false">
                                                  <select class="form-control" id ="statusFalse2" v-model="selected" disabled>
                                                          <option v-for="option in optionsUpdate"
                                                          v-bind:key="option.id"
                                                          v-bind:value="option.id">
                                                          {{option.name}}
                                                          </option>
                                                    </select>
                                                </div>
                 <p></p>
        <div class="row">
      <div class="col-md-4">

      </div>
        <div class="col-md-3">
            <button
          class="btn-cancel"
          @click="hideModal()"

        >
        {{ $t("mobilityOnDemand.editDrivers.cancel") }}
                  </button>
                    </div>
                    <div class="col-md-3">
                      <button
                    class="btn-confirm"
                    @click="saveDriver()"

                  >
                 {{ $t("mobilityOnDemand.editDrivers.confirm") }}
                  
                  </button>
                  </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/MobilityOnDemand.js";
import store from '@/vuex/store';
const api = new API_SERVICE();
export default {
    components: {
    store
  },
  props: {
    controlNumber: {
      type: String
    },
    data: {
      type: Object
    },
    details: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: false
    },
    create1: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      create:false,
      selected:"",
      name: "",
      lastName: "",
      mothersLastName: "",
      email: "",
      type: "",
      phoneNumber: "",
      status: "",
      typeUser: ""
    };
  },
  async beforeMount() {
    if(this.controlNumber) {
      await this.getDetailDriver();
      this.fillData();
    }
  },
  methods: {
       showModal() {
        if(this.selected == "choose" || this.selected == null)
               {
                  this.$store.commit("global/SET_ALERT", {
                  msg: `${this.$t("mobilityOnDemand.editDrivers.invalidOption")}`,
                  show: true,
                  type: "error"
                });
               return;
               }
               else
                      {
                      this.$refs['my-modal'].show()
                      }
      },
          hideModal() {
            this.$refs['my-modal'].hide()
          },
 
          link() {
             this.$router.push({name: "Drivers Mobility"});
          },
    getDetailDriver: async function() {
      
      this.$store.commit("global/SET_LOADING", true);
      try {
        var jsonR = {limit: 1,page: 1,query:{"control_number":this.controlNumber}};
        const resp = await api.getDriversList(jsonR);
        this.busDriver = resp.data;
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
         this.$store.commit("global/SET_ALERT", {
                  msg: `${"Detail :"+ error}`,
                  show: true,
                  type: "error"
                });
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    translateStatus(status) {
      if (status == true){
      status = this.$t("mobilityOnDemand.driversMobility.active")
      this.create = false;
      this.selected = true;
      }
      else if(status == false){
       status = this.$t("mobilityOnDemand.driversMobility.inactive")
       this.create = false;
       this.selected = false;
      }
       else if(status == null){
       status =  this.$t("mobilityOnDemand.driversMobility.noDriver")
       this.create = true;
       this.selected = null;
       }
       else {
        status
      }
        return status
    },
    fillData: function() {
      try {
        let id = this.$route.params.id;
        this.name = this.busDriver[0].name;
        this.lastName = this.busDriver[0].last_name;
        this.mothersLastName = this.busDriver[0].mothers_last_name;
        this.email = this.busDriver[0].email;
        this.type = this.busDriver[0].type;
        this.phoneNumber = this.busDriver[0].personal_phone_number;
        this.typeUser = this.busDriver[0].user_type;
        this.status = this.translateStatus(this.busDriver[0].driver_status);

      } catch (error) {
          this.$store.commit("global/SET_ALERT", {
                  msg: `${"Error in fillData :"+ error}`,
                  show: true,
                  type: "error"
                });
        
      }
    },

      async saveDriver() {
       

       
        this.$store.commit("global/SET_LOADING", true);
        try {
          
          
          if (this.create) {
            var jsonR = {"controlNumber":this.controlNumber};

           const resp = await api.createDriver(jsonR);

            this.$store.commit("global/SET_LOADING", false);
            store.commit('global/SET_RESP', "success"); 
               this.$store.commit("global/SET_ALERT", {
                 msg: `${this.$t("mobilityOnDemand.editDrivers.addDriver")}`+" :"+this.controlNumber,
                 show: true,
                 type: "success"
               });
             this.$router.push({name: "Drivers Mobility"});

         }
         else if(this.create == false){
          
           if(this.selected == false){
             var Save = {"controlNumber":this.controlNumber, "userType": "collaborator"};
              await api.saveUser(Save);
           }
           else if(this.selected == true){
             var Save = {"controlNumber":this.controlNumber, "userType": "mobility_car_driver"};
              await api.saveUser(Save);
           }
            var jsonR = {"driver_status": this.selected,"control_number":this.controlNumber};
            const resp = await api.updateDriver(jsonR);
                 this.$store.commit("global/SET_LOADING", false);
                 this.$store.commit("global/SET_ALERT", {
                 msg: `${this.$t("mobilityOnDemand.editDrivers.updateDriver")}`+ " :"+this.controlNumber,
                 show: true,
                 type: "success"
               });
             this.$router.push({
            name: "Drivers Mobility"
             });
            
         }
        }
         catch (error) {
                 
                 this.$store.commit("global/SET_LOADING", false);
                 this.$store.commit("global/SET_ALERT", {
                 msg: `${'Error trying to create driver: ', error}`,
                 show: true,
                 type: "error"
               });
               this.hideModal();
          
        }
      
    },

  },
  computed: {
     options(){
        return[
                {id:"choose",name: this.$t('mobilityOnDemand.choose')} ,
                {id:true,name: this.$t("mobilityOnDemand.driversMobility.active")} ,
                {id:null,name: this.$t("mobilityOnDemand.driversMobility.noDriver")}
              ]},
         optionsUpdate(){
        return[
                {id:"choose",name: this.$t('mobilityOnDemand.choose')} ,
                {id:true,name: this.$t("mobilityOnDemand.driversMobility.active")} ,
                {id:false,name: this.$t("mobilityOnDemand.driversMobility.inactive")}
               ]},
  
  }
};
</script>
<style media="screen">


.alertBg {
  border-left: 10px solid #ffeb3b;
  text-align: center;
  background: #fff;
 
}
.RedText {
  color: #ff465a;
  text-align: center;
  font:bold;
}

 .alertText {
  color: #FFCD00;
  text-align: center;
  font:bold;

}
	@media (min-width: 600px) {
		#modal-sample-morphing-layer .aui-modal-dialog__body {
			/* Define a width for this specific dialog: */
			width: 93.75%;
			max-width: 460px;
		}
	}
</style>

<style lang="scss" scoped>


@font-face {
  font-family: "audi-extended";
  src: url('~@/assets/fonts/AudiType-ExtendedNormal.ttf');
  font-weight: bold;
}
.return {
  color: black;
  cursor: pointer;
}
.return:hover {
  text-decoration: underline !important;
  color: black;
}
.labelBold {
  font-weight: bold;
  color: #000;
}

.driversEdit {
  background-color: $white;
  padding: 2rem 4rem;
}
.btn-download {
  padding: 2rem 2rem;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 0px;
}

.btn-confirm {
  margin-left: 1rem;
  padding:1rem 1.5rem;
  background: #000;
  color: #fff;
  border: 1px solid #000;
  border-radius: 0px;
  
}
.btn-cancel {

  padding:1rem 1.5rem;
  background: #fff;
  color: #000;
  border: 1px solid #000;
  border-radius: 0px;
 
}

.aui-headline-3{
  font-family: 'audi-extended';
  font-weight: 500;
  letter-spacing: -0.015em;
  padding: 2rem 2rem;
  }



</style>
